import { catchError, filter, map, Observable, of } from 'rxjs';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { SearchService } from '../../services/search.service';
import { Result } from '../../search/models/results.model';

@Component({
  selector: 'app-header',
  imports: [AsyncPipe, RouterLink, RouterLinkActive],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {
  public times = signal(false);
  public th = signal(true);
  public search: any;
  public families: any;
  public solutions: any;
  public page: string;
  public extraMenu = false;
  public isOpen = false;

  @ViewChild('itemNew') itemNew!: ElementRef;
  @ViewChild('itemUsed') itemUsed!: ElementRef;
  @ViewChild('itemSpare') itemSpare!: ElementRef;
  @ViewChild('itemService') itemService!: ElementRef;
  @ViewChild('itemDS') itemDS!: ElementRef;
  @ViewChild('linkNew') linkNew!: ElementRef;
  @ViewChild('linkUsed') linkUsed!: ElementRef;
  @ViewChild('linkSpare') linkSpare!: ElementRef;
  @ViewChild('linkService') linkService!: ElementRef;
  @ViewChild('linkDS') linkDS!: ElementRef;
  @ViewChild('inputSearch') inputSearch!: ElementRef;
  @ViewChild('resultsInput') resultsInput!: ElementRef;
  @ViewChild('contentLinksNav') contentLinksNav!: ElementRef;
  @ViewChild('buttonMenuMobile') buttonMenuMobile!: ElementRef;
  public linkActive: number;
  public isMobile: boolean;
  private router = inject(Router);
  private searchService = inject(SearchService);
  public results$!: Observable<Result[]>;

  constructor() {
    this.search = '';
    this.page = '';
    this.linkActive = 0;
    this.isMobile = false;
    // this.renderer.listen('window', 'click', (e: Event) => {
    //   if (e.target !== this.inputSearch.nativeElement) {
    //     this.closeSerchBox();
    //   }
    // });
    // Under OnPush ngDoCheck is not reliably called on navigation; react to router events instead.
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.resetOnNavigation());
  }

  ngOnInit(): void {
    this.collapseNavbar();
    this.onResize();
  }

  private resetOnNavigation() {
    if (typeof document !== 'undefined') {
      if (this.page !== document.location.pathname) {
        const display = document.getElementById('menuCompanies');
        if (display) display.style.display = 'none';
        document.body.style.overflowY = 'auto';
        this.times.set(false);
        this.th.set(true);
        this.page = document.location.pathname;
      }
    }
  }

  @HostListener('window:resize', [])
  onResize() {
    if (typeof window !== 'undefined') {
      const mobile = window.innerWidth <= 992;
      this.extraMenu = mobile;
      this.isMobile = mobile;
    }
  }

  private scrollRaf: number | null = null;

  @HostListener('window:scroll')
  onScroll() {
    if (typeof window === 'undefined') return;
    if (this.scrollRaf) return;
    this.scrollRaf = requestAnimationFrame(() => {
      this.scrollRaf = null;
      const scrollTop = window.scrollY;
      const nav = document.getElementsByClassName('navbar');
      const movil = document.getElementById('menuCompanies');
      if (scrollTop > 46) {
        for (const el of nav) (el as HTMLElement).classList.add('fixed-top');
        if (movil) movil.style.display = 'none';
      } else {
        for (const el of nav) (el as HTMLElement).classList.remove('fixed-top');
        if (movil) {
          movil.style.top = this.isMobile ? '60px' : '47px';
          movil.style.display = '';
        }
      }
    });
  }

  collapseNavbar() {
    if (typeof document !== 'undefined') {
      const navbarCollapse = document.querySelector('.navbar-collapse');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        (navbarCollapse as HTMLElement).classList.remove('show');
      }
    }
  }

  menuCompanyMovil(icon: any) {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menuCompanies');
      if (icon === 'times') {
        this.times.set(false);
        this.th.set(true);
        display!.style.display = 'none';
        document.body.style.overflowY = 'auto';
      } else {
        this.times.set(true);
        this.th.set(false);
        display!.style.display = 'block';
        document.body.style.overflowY = 'hidden';
      }
    }
  }

  searchIt(event: any) {
    if (event.keyCode == 13 || event.key === 'Enter') {
      const word = event.target.value;
      if (typeof window !== 'undefined') {
        window.location.pathname = '/buscador/' + word;
      }
    }
  }

  openSearch() {
    if (typeof document !== 'undefined') {
      const box = document.getElementById('searchMovil');
      box!.style.display = 'block';
      box!.getElementsByTagName('input')[0].focus();
    }
  }

  closeMenu() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('lockScroll');
      this.contentLinksNav.nativeElement.classList.remove('opened');
      this.contentLinksNav.nativeElement.style.display = 'none';
      this.buttonMenuMobile.nativeElement.classList.remove('active');
    }
  }

  showCompaniesMenu() {
    if (typeof document !== 'undefined') {
      const menu = document.getElementById('menuCompanies');
      menu!.style.display = 'block';
      const btnSities = document.getElementsByClassName('sities');
      if (!btnSities[0].classList.contains('open')) {
        btnSities[0].classList.add('open');
      }
    }
  }

  showMenuPurchase() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menuPurchase');
      const display1 = document.getElementById('menu-purchase');
      display!.setAttribute('style', 'display: block !important');
      display1!.setAttribute('style', 'display: block !important');
      display!.style.left = '0%';
      document.body.style.overflowY = 'hidden';
    }
  }

  showMainMenuMobile(): void {
    if (this.buttonMenuMobile.nativeElement.classList.contains('active')) {
      if (typeof document !== 'undefined') {
        document.body.classList.remove('lockScroll');
        const menPrchase = document.getElementById('menuPurchase') as HTMLElement;
        menPrchase.setAttribute('style', 'display: none');
        const megamenu = document.getElementById('megamenu');
        megamenu?.classList.remove('showMegamenu');
        const megamenuUsed = document.getElementById('megamenuUsed');
        megamenuUsed?.classList.remove('showMegamenu');
        const megamenuSpare = document.getElementById('megamenuSpare');
        megamenuSpare?.classList.remove('showMegamenu');
        const megamenuService = document.getElementById('megamenuService');
        megamenuService?.classList.remove('showMegamenu');
        const megamenuDS = document.getElementById('megamenuDigitalSolutions');
        megamenuDS?.classList.remove('showMegamenu');
        document.body.classList.remove('lockScroll');
      }
      this.closeMenu();
      return;
    }
    this.contentLinksNav.nativeElement.style.display = 'flex';
    this.contentLinksNav.nativeElement.classList.add('opened');
    this.buttonMenuMobile.nativeElement.classList.add('active');
    if (typeof document !== 'undefined') {
      const categories = document.querySelector('.megamenu .categories') as HTMLElement;
      const subcategories = document.querySelector('.megamenu .subcategories') as HTMLElement;
      if (categories && subcategories) {
        categories.style.display = 'block';
        subcategories.style.display = 'none';
      }
      document.body.classList.add('lockScroll');
      const menPrchase = document.getElementById('menuPurchase') as HTMLElement;
      menPrchase.setAttribute('style', 'display: none');
      const megamenu = document.getElementById('megamenu');
      megamenu?.classList.remove('showMegamenu');
      const megamenuUsed = document.getElementById('megamenuUsed');
      megamenuUsed?.classList.remove('showMegamenu');
      const megamenuSpare = document.getElementById('megamenuSpare');
      megamenuSpare?.classList.remove('showMegamenu');
      const megamenuService = document.getElementById('megamenuService');
      megamenuService?.classList.remove('showMegamenu');
      const megamenuDS = document.getElementById('megamenuDigitalSolutions');
      megamenuDS?.classList.remove('showMegamenu');
    }
  }

  // megamenu new
  openMegaMenuNew(): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        this.linkNew.nativeElement.classList.add('opened');
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenu');
        megamenu?.classList.add('showMegamenu');
        const gradient = document.getElementById('gradient');
        gradient?.classList.add('showMegamenu');
      }
    } else {
      if (typeof document !== 'undefined') {
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenu');
        megamenu?.classList.add('showMegamenu');
      }
    }
  }

  checkIsMegaMenuOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.querySelector('.megamenu .containerColumns');
          if (
            !this.itemNew.nativeElement.matches(':hover') &&
            !megamenuColumns?.matches(':hover')
          ) {
            document.body.classList.remove('lockScroll');
            this.linkNew.nativeElement.classList.remove('opened');
            const megamenu = document.getElementById('megamenu');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradient');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 100);
  }

  closeMegaMenu(): void {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        document.body.classList.remove('lockScroll');
        this.linkNew.nativeElement.classList.remove('opened');
        const megamenu = document.getElementById('megamenu');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradient');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  // megamenu used
  openMegaMenuUsed(): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        this.linkUsed.nativeElement.classList.add('opened');
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuUsed');
        megamenu?.classList.add('showMegamenu');
        const gradient = document.getElementById('gradientUsed');
        gradient?.classList.add('showMegamenu');
      }
    } else {
      if (typeof document !== 'undefined') {
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuUsed');
        megamenu?.classList.add('showMegamenu');
      }
    }
  }

  checkIsMegaMenuUsedOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.querySelector('.megamenuUsed .containerColumns');
          if (
            !this.itemUsed.nativeElement.matches(':hover') &&
            !megamenuColumns?.matches(':hover')
          ) {
            document.body.classList.remove('lockScroll');
            this.linkUsed.nativeElement.classList.remove('opened');
            const megamenu = document.getElementById('megamenuUsed');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientUsed');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 100);
  }

  closeMegaMenuUsed(): void {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        document.body.classList.remove('lockScroll');
        this.linkUsed.nativeElement.classList.remove('opened');
        const megamenu = document.getElementById('megamenuUsed');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientUsed');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  // megamenu spare
  openMegaMenuSpare(): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        this.linkSpare.nativeElement.classList.add('opened');
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuSpare');
        megamenu?.classList.add('showMegamenu');
        const gradient = document.getElementById('gradientSpare');
        gradient?.classList.add('showMegamenu');
      }
    } else {
      if (typeof document !== 'undefined') {
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuSpare');
        megamenu?.classList.add('showMegamenu');
      }
    }
  }

  checkIsMegaMenuSpareOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.querySelector('.megamenuSpare .containerColumns');
          if (
            !this.itemSpare.nativeElement.matches(':hover') &&
            !megamenuColumns?.matches(':hover')
          ) {
            document.body.classList.remove('lockScroll');
            this.linkSpare.nativeElement.classList.remove('opened');
            const megamenu = document.getElementById('megamenuSpare');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientSpare');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 100);
  }

  closeMegaMenuSpare(): void {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        document.body.classList.remove('lockScroll');
        this.linkSpare.nativeElement.classList.remove('opened');
        const megamenu = document.getElementById('megamenuSpare');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientSpare');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  // megamenu service
  openMegaMenuService(el: any): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        /*const rect = el.getBoundingClientRect();
        const x = rect.left; */
        const x = el.getBoundingClientRect().left;
        const screenWidth = window.innerWidth;
        const spacing = screenWidth - x;
        // console.log('Posición X:', spacing);
        const menu = document.querySelector('.megamenuService .containerColumns') as HTMLElement;
        menu.style.right = spacing - 345 / 2 - 31 + 'px';
        this.linkService.nativeElement.classList.add('opened');
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuService');

        if (megamenu) {
          megamenu.classList.add('showMegamenu');
          //megamenu.style.marginLeft = spacing + 'px';
        }

        const gradient = document.getElementById('gradientService');
        gradient?.classList.add('showMegamenu');
      }
    } else {
      if (typeof document !== 'undefined') {
        const menu = document.querySelector('.megamenuService .containerColumns') as HTMLElement;
        menu.style.right = '0px';
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuService');
        megamenu?.classList.add('showMegamenu');
      }
    }
  }

  checkIsMegaMenuServiceOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.getElementById('categoriesServiceMenu');
          if (
            !this.itemService.nativeElement.matches(':hover') &&
            !megamenuColumns?.matches(':hover')
          ) {
            document.body.classList.remove('lockScroll');
            this.linkService.nativeElement.classList.remove('opened');
            const megamenu = document.getElementById('megamenuService');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientService');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 200);
  }

  closeMegaMenuService(): void {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        document.body.classList.remove('lockScroll');
        this.linkService.nativeElement.classList.remove('opened');
        const megamenu = document.getElementById('megamenuService');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientService');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  // megamenu digital solutions
  openMegaMenuDS(el: any): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        const x = el.getBoundingClientRect().left;
        const screenWidth = window.innerWidth;
        const spacing = screenWidth - x;
        // console.log('Posición X:', spacing);
        const menu = document.querySelector(
          '.megamenuDigitalSolutions .containerColumns'
        ) as HTMLElement;
        const menuSearch = document.querySelector('.inputSearch') as HTMLElement;
        if (menuSearch) {
          menu.style.right = spacing - 345 / 2 - 76 + 'px';
        } else {
          menu.style.right = '0px';
        }
        this.linkDS.nativeElement.classList.add('opened');
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuDigitalSolutions');
        megamenu?.classList.add('showMegamenu');
        const gradient = document.getElementById('gradientDS');
        gradient?.classList.add('showMegamenu');
      }
    } else {
      if (typeof document !== 'undefined') {
        const menu = document.querySelector(
          '.megamenuDigitalSolutions .containerColumns'
        ) as HTMLElement;
        menu.style.right = '0px';
        document.body.classList.add('lockScroll');
        const megamenu = document.getElementById('megamenuDigitalSolutions');
        megamenu?.classList.add('showMegamenu');
      }
    }
  }

  checkIsMegaMenuDSOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.getElementById('categoriesDSMenu');
          if (!this.itemDS.nativeElement.matches(':hover') && !megamenuColumns?.matches(':hover')) {
            document.body.classList.remove('lockScroll');
            this.linkDS.nativeElement.classList.remove('opened');
            const megamenu = document.getElementById('megamenuDigitalSolutions');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientDS');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 200);
  }

  closeMegaMenuDS(): void {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        document.body.classList.remove('lockScroll');
        this.linkDS.nativeElement.classList.remove('opened');
        const megamenu = document.getElementById('megamenuDigitalSolutions');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientDS');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  onKeyUp(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length === 0) {
      this.resultsInput.nativeElement.style.display = 'none';
      this.inputSearch.nativeElement.focus();
      return;
    } else {
      this.resultsInput.nativeElement.style.display = 'flex';
      this.inputSearch.nativeElement.focus();
    }
    this.results$ = this.searchService.getResultsFromInput(inputValue).pipe(
      map((res) => res.results ?? []),
      catchError((error) => {
        console.error(error);
        return of([]);
      })
    );
  }

  goToSearch(keywords: string) {
    this.closeSerchBox();
    this.router.navigate(['/buscador', keywords]);
  }

  closeSerchBox(): void {
    if (typeof document !== 'undefined') {
      this.resultsInput.nativeElement.style.display = 'none';
    }
  }

  deleteText() {
    this.inputSearch.nativeElement.value = '';
  }
}
